import React, { useEffect, useState } from "react";
import Apiservice from "../Apiservice";
import { useNavigate } from "react-router-dom";

const LeaveForm = () => {
const navigate = useNavigate();

  const [userId, setUserId] = useState(1); // Replace with actual logged-in userId
  const [siteId, setSiteId] = useState(1); // Replace with actual siteId
  const [leaveCategories, setLeaveCategories] = useState([]);
  const [leaveRows, setLeaveRows] = useState([
    { leaveCategoryId: "", fromDate: "", toDate: "", reason: "", appliedLeave: 0 },
  ]);

  // 🔹 Fetch Leave Categories
  useEffect(() => {
    const fetchData = async () => {
      setUserId(localStorage.getItem("user_id"));
      let data = { status: 0 };
      let result = await Apiservice.LeaveCategoriesGet(data);
      if (result.success === true) {
        setLeaveCategories(result.data);
      }
    };
    fetchData();
  }, []);

  // 🔹 Handle row input change with auto appliedLeave calculation
  const handleRowChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...leaveRows];
    updatedRows[index][name] = value;

    // Auto-calc appliedLeave if fromDate & toDate exist
    if (updatedRows[index].fromDate && updatedRows[index].toDate) {
      const from = new Date(updatedRows[index].fromDate);
      const to = new Date(updatedRows[index].toDate);

      if (to >= from) {
        const diffDays = Math.floor((to - from) / (1000 * 60 * 60 * 24)) + 1;
        updatedRows[index].appliedLeave = diffDays;
      } else {
        updatedRows[index].appliedLeave = 0; // invalid date range
      }
    }

    setLeaveRows(updatedRows);
  };

  // 🔹 Add new leave row
  const addLeaveRow = () => {
    setLeaveRows([
      ...leaveRows,
      { leaveCategoryId: "", fromDate: "", toDate: "", reason: "", appliedLeave: 0 },
    ]);
  };

  // 🔹 Remove leave row
  const removeLeaveRow = (index) => {
    const updatedRows = leaveRows.filter((_, i) => i !== index);
    setLeaveRows(updatedRows);
  };

  // 🔹 Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      userId,
      siteId,
      details: leaveRows, // appliedLeave is already auto-calculated
    };

    console.log("Submitting Payload:", payload);

    let result = await Apiservice.LeaveAdd(payload);
    if (result.success === true) {
      alert("Leaves applied successfully!");
     navigate("/leaveapplicationlist"); // redirect after success
    } else {
      alert("Failed to apply leaves. Please try again.");
    }
  };

  return (
    <div className="container-fluid mt-3">
      <form onSubmit={handleSubmit}>
        {/* Header */}
        <div className="row mb-2">
          <div className="col">
            <h5>LEAVE APPLICATION FORM</h5>
          </div>
        </div>

        {/* Dynamic Leave Rows */}
        {leaveRows.map((row, index) => (
          <div className="row mb-3 border p-2 rounded" key={index}>
            {/* Leave Category */}
            <div className="col">
              <label className="form-label">Leave Category</label>
              <select
                name="leaveCategoryId"
                value={row.leaveCategoryId}
                onChange={(e) => handleRowChange(index, e)}
                className="form-select"
                required
              >
                <option value="">Select Option</option>
                {leaveCategories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.category}
                  </option>
                ))}
              </select>
            </div>

            {/* From Date */}
            <div className="col">
              <label className="form-label">From Date</label>
              <input
                type="date"
                name="fromDate"
                value={row.fromDate}
                onChange={(e) => handleRowChange(index, e)}
                className="form-control"
                required
              />
            </div>

            {/* To Date */}
            <div className="col">
              <label className="form-label">To Date</label>
              <input
                type="date"
                name="toDate"
                value={row.toDate}
                onChange={(e) => handleRowChange(index, e)}
                className="form-control"
                required
              />
            </div>

            {/* Reason */}
            <div className="col">
              <label className="form-label">Reason</label>
              <input
                type="text"
                name="reason"
                value={row.reason}
                onChange={(e) => handleRowChange(index, e)}
                className="form-control"
                placeholder="Enter reason"
                required
              />
            </div>

            {/* Applied Leave (auto) */}
            <div className="col">
              <label className="form-label">Applied Leave</label>
              <input
                type="number"
                name="appliedLeave"
                value={row.appliedLeave}
                className="form-control"
                readOnly
              />
            </div>

            {/* Remove Button */}
            <div className="col-1 d-flex align-items-end">
              {leaveRows.length > 1 && (
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => removeLeaveRow(index)}
                >
                  X
                </button>
              )}
            </div>
          </div>
        ))}

        {/* Add Row Button */}
        <div className="row mb-3">
          <div className="col text-start">
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={addLeaveRow}
            >
              + Add Leave
            </button>
          </div>
        </div>

        {/* Submit Button */}
        <div className="row">
          <div className="col text-center">
            <button type="submit" className="btn btn-primary btn-sm">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LeaveForm;
